import React, { useEffect, useState } from "react";
import { IFilter, IFilterGroup } from "../../../backend/interfaces/filters/IFilter";
import { connect } from "react-redux";
import { iRootState, Dispatch } from "../../../rematch/store";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import IconFilterUserDisabled from "../../../icons/IconFilterUserDisabled.png";
import { ReactComponent as IconCopy } from "../../../icons/icon-copy.svg";
import { ReactComponent as IconLock } from "../../../icons/icon-lock.svg";
import { ReactComponent as IconLockOpen } from "../../../icons/icon-lock-open.svg";
import { ReactComponent as IconTrash } from "../../../icons/icon-trash.svg";
import { List } from "./List";
import { Icon_SVG_24x24, IconSettingsButton22x22 } from "../common/Buttons";
import { FilterComponentHeader } from "./FiltersCommon";

const Button = styled(IconSettingsButton22x22)`
  height: 100%;
  flex: 0 0 22px;
  display: flex;
  margin-left: auto;
`;

const Button_SVG = styled(Icon_SVG_24x24)`
  height: 100%;
  flex: 0 0 24px;
  display: flex;
  margin-left: auto;
`;

const FilterNameLabelOuter = styled.div`
  padding-right: 5px;
  overflow-x: hidden;
  flex: 1;
`;

const FilterNameLabelInner = styled.div`
  overflow-x: hidden;
`;

const FilterCheckbox = styled.input`
 margin-right: 5px;
 width: 16px;
 height: 16px;
`;

interface ISaveFiltersItemProps {
  index: number;
  name: string;
  checked: boolean;
  locked: boolean;
  external: boolean;
  onChange: () => void;
  onDelete: () => void;
  onLock: () => void;
  onCopy: () => void;
  onSelect: () => void;
}

const SaveFiltersItem = (props: ISaveFiltersItemProps) => {
  const onClick = (event) => event.stopPropagation();
  return (
    <>
      <FilterCheckbox type={"checkbox"} onClick={onClick} checked={props.checked} onChange={props.onChange} />
      <FilterNameLabelOuter onClick={ props.onSelect } style={{ cursor: "pointer"}}>
        <FilterNameLabelInner>{ props.name }</FilterNameLabelInner>
      </FilterNameLabelOuter>
      <Button_SVG onClick={ props.onCopy } >
        <IconCopy />
      </Button_SVG>
      { props.external && <Button disabled={true} imageDisabled={IconFilterUserDisabled} /> }
      { !props.external && !props.locked 
        ? <Button_SVG disabled={props.external} onClick={ props.onLock } >
          <IconLockOpen />
        </Button_SVG>
        : <Button_SVG disabled={props.external} onClick={ props.onLock } >
          <IconLock />
        </Button_SVG>
      }
      { !props.external && 
        <Button_SVG disabled={props.external} onClick={ props.onDelete } >
          <IconTrash />
        </Button_SVG>
      }
    </>
  );
};

interface ISavedFiltersListProps {
  viewIndex: number;
  getFilters: (viewIndex: number) => IFilterGroup[];
  enabledFilters: number[][];
  selectedFilter?: IFilter;
  onCopy: (selectedFilter: IFilterGroup) => void;
  onChange: (selectedFilter: IFilterGroup) => void;
  toggleEnabled: (viewIndex: number, filterName: string, ownerId: number) => void;
  toggleLocked: (viewIndex: number, filterName: string, ownerId: number) => void;
  deletePanelFilter: (viewIndex: number, filterName: string) => void;
  userId: number;
}

const SavedFiltersList = (props: ISavedFiltersListProps) => {

  const { t } = useTranslation();

  const items = props.getFilters(props.viewIndex)?.map((fg, index) => {
    const checked = props.enabledFilters[props.viewIndex]?.includes(index);
    return (
      <SaveFiltersItem
        key={`${fg.name}-${checked}`}
        index={index}
        name={fg.name}
        locked={fg.locked}
        external={fg.ownerId !== props.userId}
        checked={checked}
        onChange={() => props.toggleEnabled(props.viewIndex, fg.name, fg.ownerId)}
        onDelete={() => props.deletePanelFilter(props.viewIndex, fg.name)}
        onLock={() => props.toggleLocked(props.viewIndex, fg.name, fg.ownerId)}
        onCopy={() => props.onCopy(fg) }
        onSelect={() => props.onChange(fg)}
      />
    );
  }) ?? [];

  return (
    <>
      <FilterComponentHeader>{t("filter.saved")}</FilterComponentHeader>
      <List
        items={items}
        size={8}
      />
    </>
  );
};

export default connect(
  (rootState: iRootState) => ({
    getFilters: (viewIndex: number) => rootState.filters.panelFilters[viewIndex] ?? [],
    enabledFilters: rootState.filters.enabledPanelFilters,
    userId: rootState.common.configuration.userId,
  }),
  (dispatch: Dispatch) => ({
    toggleEnabled: (viewIndex: number, filterName: string, ownerId: number) => dispatch.filters.toggleEnabled({ viewIndex, filterName, ownerId }),
    toggleLocked: (viewIndex: number, filterName: string, ownerId: number) => { 
      dispatch.filters.toggleLocked({ viewIndex, filterName, ownerId });
      dispatch.filters.savePanelFiltersAsync(null);
    },
    deletePanelFilter: (viewIndex: number, filterName: string) => dispatch.filters.deletePanelFilterAsync({ filterName: filterName, viewIndex: viewIndex }),
  })
)(SavedFiltersList);
